import { render, staticRenderFns } from "./HoverItem.vue?vue&type=template&id=ad080602&scoped=true"
import script from "./HoverItem.vue?vue&type=script&lang=js"
export * from "./HoverItem.vue?vue&type=script&lang=js"
import style0 from "./HoverItem.vue?vue&type=style&index=0&id=ad080602&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad080602",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad080602')) {
      api.createRecord('ad080602', component.options)
    } else {
      api.reload('ad080602', component.options)
    }
    module.hot.accept("./HoverItem.vue?vue&type=template&id=ad080602&scoped=true", function () {
      api.rerender('ad080602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/HoverItem.vue"
export default component.exports